import { createSelector } from 'reselect';
import { getStringProp } from '@mews/fp';
import { parentSelector } from '../../selectors/parentSelector';

export const getPromotedServiceCategories = createSelector(
    parentSelector,
    (state) => state.data.promotedServiceCategories
);

export const getPromotedServiceCategory = createSelector(
    getPromotedServiceCategories,
    getStringProp('categoryId'),
    (promotedServiceCategories, categoryId) => promotedServiceCategories[categoryId]
);
